import { useState, useEffect } from "react";
import { queryAllDatasets, queryAllModels } from "../../utils/fine-tuning-functions";
import DatasetsLayout from "./DatasetsLayout";
import ModelLayout from "./ModelLayout";
import CompareModels from "./CompareModels";
import Sidebar from "../Sidebar";

export default function FineTuning({ setAuth, setUserOrg, userId }) {
  const [datasets, setDatasets] = useState(null);
  const [models, setModels] = useState(null);
  const [activeTab, setActiveTab] = useState("datasets"); 
  const [isCompareModalOpen, setIsCompareModalOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setDatasets(await queryAllDatasets());
      setModels(await queryAllModels());
    };

    fetchData();

    const intervalId = setInterval(fetchData, 5000); 

    return () => clearInterval(intervalId);
  }, []);
  
  // Tab switching handler
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="h-[100dvh]">
        <div className="flex h-[100%] fixed top-0">
          <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
        </div>
      </div>
      <div
        className="flex flex-col w-full"
        style={{
          marginLeft: "var(--sidebar-width, 250px)",
          width: "calc(100% - var(--sidebar-width, 250px))",
        }}
      >
        <header className="bg-white shadow-sm p-4 flex items-center justify-between">
        <div className="flex items-center">
          <h1 className="font-bold text-[28px] text-ktx-purple">AI Model Fine-Tuning</h1>
        </div>
        
        {/* Compare Models Button */}
        <button
          onClick={() => setIsCompareModalOpen(true)}
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-ktx-purple hover:bg-ktx-purple-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ktx-purple transition-colors"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5 mr-2" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" 
            />
          </svg>
          Compare Models
        </button>
        </header>

        <div className="flex border-b border-gray-200 bg-white">
        <button
          onClick={() => handleTabChange("datasets")}
          className={`py-4 px-8 font-medium text-lg ${
            activeTab === "datasets"
              ? "border-b-2 border-ktx-purple text-ktx-purple"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <div className="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" />
              <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" />
              <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" />
            </svg>
            Datasets
          </div>
        </button>
        <button
          onClick={() => handleTabChange("models")}
          className={`py-4 px-8 font-medium text-lg ${
            activeTab === "models"
              ? "border-b-2 border-ktx-purple text-ktx-purple"
              : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <div className="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z" clipRule="evenodd" />
            </svg>
            Models
          </div>
        </button>
        </div>

        <div className="flex-1 p-6 max-w-6xl mx-auto w-full">
          {activeTab === "datasets" ? (
            <DatasetsLayout datasets={datasets} setDatasets={setDatasets} />
          ) : (
            <ModelLayout models={models} />
          )}
        </div>
        
        {/* Compare Models Modal */}
        <CompareModels 
          isOpen={isCompareModalOpen} 
          onClose={() => setIsCompareModalOpen(false)} 
          userId={userId} 
        />
      </div>
    </div>
  );
}